import { addMonths, endOfMonth, endOfWeek, startOfMonth, startOfWeek, startOfYear, subMonths } from 'date-fns';
import { DateRangeOption } from './type';

/**
 * Get default date range options for date search
 */
export const getDefaultDateOptions = (): DateRangeOption[] => {
  const today = new Date();

  return [
    {
      value: 'thang_nay',
      label: 'Tháng này',
      getDateRange: () => ({
        from: startOfMonth(today),
        to: endOfMonth(today)
      })
    },
    {
      value: 'dau_thang_den_hien_tai',
      label: 'Đầu tháng đến hiện tại',
      getDateRange: () => ({
        from: startOfMonth(today),
        to: today
      })
    },
    {
      value: 'thang_truoc',
      label: 'Tháng trước',
      getDateRange: () => {
        const lastMonth = subMonths(today, 1);
        return {
          from: startOfMonth(lastMonth),
          to: endOfMonth(lastMonth)
        };
      }
    },
    {
      value: 'thang_sau',
      label: 'Tháng sau',
      getDateRange: () => {
        const nextMonth = addMonths(today, 1);
        return {
          from: startOfMonth(nextMonth),
          to: endOfMonth(nextMonth)
        };
      }
    },
    {
      value: 'hom_nay',
      label: 'Hôm nay',
      getDateRange: () => ({
        from: today,
        to: today
      })
    },
    {
      value: 'tuan_nay',
      label: 'Tuần này',
      getDateRange: () => ({
        from: startOfWeek(today, { weekStartsOn: 1 }),
        to: endOfWeek(today, { weekStartsOn: 1 })
      })
    },
    {
      value: 'thang_1',
      label: 'Tháng 1',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 0, 1),
          to: new Date(year, 0, 31)
        };
      }
    },
    {
      value: 'thang_2',
      label: 'Tháng 2',
      getDateRange: () => {
        const year = today.getFullYear();
        const feb = new Date(year, 1, 1);
        return {
          from: feb,
          to: endOfMonth(feb)
        };
      }
    },
    {
      value: 'thang_3',
      label: 'Tháng 3',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 2, 1),
          to: new Date(year, 2, 31)
        };
      }
    },
    {
      value: 'thang_4',
      label: 'Tháng 4',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 3, 1),
          to: new Date(year, 3, 30)
        };
      }
    },
    {
      value: 'thang_5',
      label: 'Tháng 5',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 4, 1),
          to: new Date(year, 4, 31)
        };
      }
    },
    {
      value: 'thang_6',
      label: 'Tháng 6',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 5, 1),
          to: new Date(year, 5, 30)
        };
      }
    },
    {
      value: 'thang_7',
      label: 'Tháng 7',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 6, 1),
          to: new Date(year, 6, 31)
        };
      }
    },
    {
      value: 'thang_8',
      label: 'Tháng 8',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 7, 1),
          to: new Date(year, 7, 31)
        };
      }
    },
    {
      value: 'thang_9',
      label: 'Tháng 9',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 8, 1),
          to: new Date(year, 8, 30)
        };
      }
    },
    {
      value: 'thang_10',
      label: 'Tháng 10',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 9, 1),
          to: new Date(year, 9, 31)
        };
      }
    },
    {
      value: 'thang_11',
      label: 'Tháng 11',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 10, 1),
          to: new Date(year, 10, 30)
        };
      }
    },
    {
      value: 'thang_12',
      label: 'Tháng 12',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 11, 1),
          to: new Date(year, 11, 31)
        };
      }
    },
    {
      value: 'quy_1',
      label: 'Quý 1',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 0, 1),
          to: new Date(year, 2, 31)
        };
      }
    },
    {
      value: 'quy_2',
      label: 'Quý 2',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 3, 1),
          to: new Date(year, 5, 30)
        };
      }
    },
    {
      value: 'quy_3',
      label: 'Quý 3',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 6, 1),
          to: new Date(year, 8, 30)
        };
      }
    },
    {
      value: 'quy_4',
      label: 'Quý 4',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: new Date(year, 9, 1),
          to: new Date(year, 11, 31)
        };
      }
    },
    {
      value: 'quy_nay',
      label: 'Quý này',
      getDateRange: () => {
        const quarter = Math.floor(today.getMonth() / 3);
        const year = today.getFullYear();
        return {
          from: new Date(year, quarter * 3, 1),
          to: new Date(year, quarter * 3 + 2 + 1, 0)
        };
      }
    },
    {
      value: 'quy_truoc',
      label: 'Quý trước',
      getDateRange: () => {
        const currentQuarter = Math.floor(today.getMonth() / 3);
        let year = today.getFullYear();
        let quarter = currentQuarter - 1;
        if (quarter < 0) {
          quarter = 3;
          year -= 1;
        }
        return {
          from: new Date(year, quarter * 3, 1),
          to: new Date(year, quarter * 3 + 2 + 1, 0)
        };
      }
    },
    {
      value: 'dau_quy_den_hien_tai',
      label: 'Đầu quý đến hiện tại',
      getDateRange: () => {
        const quarter = Math.floor(today.getMonth() / 3);
        const year = today.getFullYear();
        return {
          from: new Date(year, quarter * 3, 1),
          to: today
        };
      }
    },
    {
      value: 'nam_nay',
      label: 'Năm nay',
      getDateRange: () => {
        const year = today.getFullYear();
        return {
          from: startOfYear(today),
          to: new Date(year, 11, 31)
        };
      }
    },
    {
      value: 'nam_truoc',
      label: 'Năm trước',
      getDateRange: () => {
        const year = today.getFullYear() - 1;
        return {
          from: new Date(year, 0, 1),
          to: new Date(year, 11, 31)
        };
      }
    },
    {
      value: 'dau_nam_den_hien_tai',
      label: 'Đầu năm đến hiện tại',
      getDateRange: () => ({
        from: startOfYear(today),
        to: today
      })
    }
  ];
};
